import { ListingCardTransformationHelper } from '@smg-real-estate/domus';
import { Attachment } from '@smg-real-estate/hg-rets-schema';
import { ListingCard, ListingCardSize } from '@smg-real-estate/hg-search-libs';

export interface PreloadLink {
  rel: string;
  href?: string;
  as: string;
  imagesizes: string;
  imagesrcset: string;
  fetchpriority?: string;
  media?: string;
}

function createPreloadLinks(imageUrl: string, isMediumOrLargeListingCard: boolean): PreloadLink[] {
  const { sizes, srcSet } = ListingCardTransformationHelper.getMobileImageSource(
    imageUrl,
    isMediumOrLargeListingCard,
  );

  return [
    {
      as: 'image',
      rel: 'prefetch',
      imagesizes: sizes,
      imagesrcset: srcSet,
      fetchpriority: 'high',
      media: '(max-width: 767px)',
    },
  ];
}

export const getPreloadLinks = (
  images: Attachment[],
  listingCard: ListingCard | undefined,
): PreloadLink[] => {
  // if images or listingCard are undefined return empty array
  if (!images.length || !listingCard) {
    return [];
  }

  const firstImageUrl = images[0]?.url;
  if (!firstImageUrl) {
    return [];
  }

  return createPreloadLinks(firstImageUrl, listingCard.size !== ListingCardSize.SMALL);
};
